
export default function typeofCard(type){
  if (type==="D"){
    return '借记卡'
  } else if (type==='C'){
    return '贷记卡'
  } else if (type==='Z'){
    return '准贷记卡'
  } else if (type==='Y'){
    return '预付卡'
  } else {
    return '其他'
  }
}



// WEBPACK FOOTER //
// ./src/modules/filter/bankCardType.js